import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { isNewAccount, isTourOpen, markSeen, TOUR_STATE_EVENT, wasSeen } from "../../helpers/tour/tour";
import { placeCard, useTargetRect } from "../CabinetTour/useTargetRect";
import * as styled from "./Hint.styled";

// Одноразова підказка біля кнопки, коли людина вперше до неї дійшла (наприклад, перше ДЗ). Лише новим акаунтам.
// Ставиться поруч з елементом з data-hint={id}; закривається «Зрозуміло» або натисканням на сам елемент.
function Hint({ id, text }) {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.auth);
  const [tourOpen, setTourOpen] = useState(isTourOpen);
  const [height, setHeight] = useState(90);
  const [modalOpen, setModalOpen] = useState(false);
  const ref = useRef(null);
  const selector = `[data-hint="${id}"]`;
  const active = Boolean(data) && isNewAccount(data) && !wasSeen(data, id) && !tourOpen && !modalOpen;
  const rect = useTargetRect(selector, active);

  useEffect(() => {
    const onTour = () => setTourOpen(isTourOpen());
    window.addEventListener(TOUR_STATE_EVENT, onTour);
    return () => window.removeEventListener(TOUR_STATE_EVENT, onTour);
  }, []);

  // Поки відкрите вікно (зірки, новинка) — підказка не просвічує крізь нього
  useEffect(() => {
    const check = () => setModalOpen(Boolean(document.querySelector('[aria-modal="true"]')));
    check();
    const timer = setInterval(check, 500);
    return () => clearInterval(timer);
  }, []);

  // Натиснули на саму кнопку — підказка зробила свою справу
  useEffect(() => {
    if (!active || !rect) return;
    const element = document.querySelector(selector);
    const done = () => markSeen(dispatch, id);
    element?.addEventListener("click", done);
    return () => element?.removeEventListener("click", done);
  }, [active, rect, selector, dispatch, id]);

  useLayoutEffect(() => {
    if (ref.current) setHeight(ref.current.offsetHeight);
  }, [rect, active]);

  if (!active || !rect) return null;
  const place = placeCard(rect, { width: 280, height }, 12);

  return createPortal(
    <>
      <styled.Ring style={{ top: rect.top - 4, left: rect.left - 4, width: rect.width + 8, height: rect.height + 8 }} />
      <styled.Bubble ref={ref} role="status" style={{ top: place.top, left: place.left, width: place.width }}>
        <p>{text}</p>
        <button type="button" onClick={() => markSeen(dispatch, id)}>
          Зрозуміло
        </button>
      </styled.Bubble>
    </>,
    document.body
  );
}

export default Hint;
